import { useTranslation } from 'react-i18next';

export default function Stats() {
  const { t, i18n } = useTranslation();

  const uiLang = (i18n?.language || 'en').slice(0, 2);

  const statNumberFallbacks = {
    en: {
      priority: 'PRIORITY',
    },
    pt: {
      priority: 'PRIORIDADE',
    },
    de: {
      priority: 'PRIORITÄT',
    },
    fr: {
      priority: 'PRIORITÉ',
    },
    es: {
      priority: 'PRIORIDAD',
    },
  };

  const sf = statNumberFallbacks[uiLang] || statNumberFallbacks.en;

  return (
    <div className="stats-section">
      <div className="stat-item">
        <span className="stat-n">3</span>
        <span className="stat-label">
          {t('landing.stats.coreTools', { defaultValue: 'CORE TOOLS' })}
        </span>
      </div>

      <div className="stat-item">
        <span className="stat-n">3</span>
        <span className="stat-label">
          {t('landing.stats.plans', { defaultValue: 'PLANS' })}
        </span>
      </div>

      <div className="stat-item">
        <span className="stat-n">6</span>
        <span className="stat-label">
          {t('landing.stats.plusLanguages', { defaultValue: 'OUTPUT LANGUAGES' })}
        </span>
      </div>

      <div className="stat-item">
        <span className="stat-n">
          {t('landing.stats.priorityWord', { defaultValue: sf.priority })}
        </span>
        <span className="stat-label">
          {t('landing.stats.proLanguages', { defaultValue: 'ACCESS TO NEW LANGUAGES' })}
        </span>
      </div>
    </div>
  );
}